// Destination values
export const NON_BINDING = 'non-binding';
export const BINDING = 'binding';
export const INSTANT = 'instant';
